

import * as type from './mutation-type';

export default {


  /**
   * 设置页面是否显示
   * @param state
   * @param type  {Boolean}
   */
  [type.SET_TABLE_CHECK] (state,type){
    state.table_check = type;
  },

  /**
   * 设置站点配置
   * @param state
   * @param config {Object}
   */
  [type.SET_SITE_CONFIG] (state, config){
    state.siteConfig = config || {};
  },


}


// WEBPACK FOOTER //
// ./src/store/mutations.js